module.exports = __webpack_public_path__ + "static/img/alert_image.8e74fa9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/alert_image.png
// module id = fzr/
// module chunks = 1